<template>
  <FilterPracticeOptions v-model="selected" :options="expansion">
    Wachstumsphase
  </FilterPracticeOptions>
</template>

<script setup>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { expansion } from '@/static/enums';

const props = defineProps({'modelValue': Array});
const emits = defineEmits(['update:modelValue']);
const selected = ref(new Array);

const emitter = (value) => emits('update:modelValue', value);
const watcher = watchEffect(() => emitter(selected.value));
</script>
